const serviceConfig = {
  moodleService: {
    baseURL: 'https://lrns.2pisolutions.com/webservice/rest/server.php'
    // Please add Other configuration specific to the moodle service...
  },
  vAssistService: {
    baseURL: 'https://lrns.2pisolutions.com/'
    // Please add configuration specific to the vAssist service...
  },
  moodleFreeVlearnService: {
    baseURL: 'https://previewvlearn.insidelearnings.com/webservice/rest/server.php'
  },
  freeCourseArticle: {
    baseURL: ''
  },
  PrimerootEnrollmentService: {
    baseURL:
      ''
  },
  SpringBootToNodeApis: {
    baseURL: ''
  }
};

const backendBaseUrl = 'https://lrns.2pisolutions.com';
const freeBackendBaseUrl = 'https://previewvlearn.insidelearnings.com';
const backendApiUrl = serviceConfig.moodleService.baseURL;
const assetUrl = 'https://assets.insidelearnings.com/vlearn';
const intelliLearnWebUrl = 'https://lrns.2pisolutions.com/';
const intelliLearnLMSWebUrl = 'https://lrns.2pisolutions.com';
const intelliLearnLMSApiUrl = serviceConfig.vAssistService.baseURL;
const vAssistUrl = 'https://api.insidelearnings.com';
const notificationUrl = 'https://notification-service.insidelearnings.com';
const PUBLIC_URL = window.location.origin;
const ZOOM_ENV = {
};
const CLEVERTAP_ACCOUNT = {
  ACCOUNT_ID: '7645345768765',
  REGION: ''
};

export {
  serviceConfig,
  backendBaseUrl,
  freeBackendBaseUrl,
  backendApiUrl,
  intelliLearnWebUrl,
  intelliLearnLMSWebUrl,
  intelliLearnLMSApiUrl,
  vAssistUrl,
  ZOOM_ENV,
  CLEVERTAP_ACCOUNT,
  assetUrl,
  PUBLIC_URL,
  notificationUrl
};
